<pax-section
  [sectionTitle]="productSpecificCustomRouteData.pageTitle"
  [sectionSubtitle]="productSpecificCustomRouteData.pageSubtitle"
  [emojis]="emojis"
>
  <!-- Contact Support -->
  <app-contact-support></app-contact-support>
</pax-section>
